import { useEffect } from "react";

const upsert = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs.match || {}).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  Object.entries(attrs.set || {}).forEach(([k, v]) => el.setAttribute(k, v));
};

export const useSeo = ({ title, description, path, image = "/products/hero-villa.png" }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      upsert('meta[name="description"]', {
        match: { name: "description" },
        set: { name: "description", content: description },
      });
    }
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const url = `${origin}${path || ""}`;
    const ogImage = image.startsWith("http") ? image : `${origin}${image}`;

    const og = [
      ["og:title", title],
      ["og:description", description],
      ["og:type", "website"],
      ["og:url", url],
      ["og:image", ogImage],
      ["og:locale", "sv_SE"],
      ["og:site_name", "Vido Klimatteknik"],
    ];
    og.forEach(([prop, val]) => {
      if (!val) return;
      upsert(`meta[property="${prop}"]`, {
        match: { property: prop },
        set: { property: prop, content: val },
      });
    });

    const tw = [
      ["twitter:card", "summary_large_image"],
      ["twitter:title", title],
      ["twitter:description", description],
      ["twitter:image", ogImage],
    ];
    tw.forEach(([name, val]) => {
      if (!val) return;
      upsert(`meta[name="${name}"]`, {
        match: { name },
        set: { name, content: val },
      });
    });

    // Canonical
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path, image]);
};

export default useSeo;
